<!-- <p>lodge-complaint-diaog works!</p> -->
<div class="mat-dialog-header">
  <h1 mat-dialog-title>
    Request Form
    <button mat-mini-fab mat-dialog-close cdkFocusInitial>
      <mat-icon>clear</mat-icon>
    </button>
  </h1>
</div>
<mat-dialog-content class="mat-typography">
  <div class="tickets-dialog-options">
    <form [formGroup]="lodgeComplaintTicket">
      <mat-form-field appearance="outline">
        <mat-label>Subject </mat-label>
        <mat-select
          (selectionChange)="onChangeComplainType($event)"
          formControlName="complainSubject"
        >
          <mat-option [disabled]="isDisableFeature" value="Service Request">
            Service Request</mat-option
          >
          <mat-option [disabled]="isDisableFeature" value="Complain">
            Complain
          </mat-option>
          <mat-option [disabled]="isDisableFeature" value="Claim">
            Claim
          </mat-option>
          <mat-option [disabled]="isDisableFeature" value="HouseKeeping">
            House Keeping
          </mat-option>
          <mat-option
            [disabled]="!isEmployee || isDisableFeature"
            value="Leave"
          >
            Leave
          </mat-option>
          <mat-option [disabled]="isDisableFeature" value="Electrical">
            Electrical
          </mat-option>
          <mat-option [disabled]="isDisableFeature" value="Plumbing">
            Plumbing
          </mat-option>
          <mat-option
            [disabled]="isDisableFeature"
            value="Horticulture/Landscaping"
          >
            Horticulture/Landscaping
          </mat-option>
          <mat-option value="Support"> Support </mat-option>
          <mat-option value="Vendor"> Vendor Request </mat-option>
          <mat-option [disabled]="isDisableFeature" value="Other">
            Other
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div
        *ngIf="
          lodgeComplaintTicket.controls.complainSubject.value ===
          'Service Request'
        "
      >
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Select Request Type </mat-label>
          <mat-select formControlName="requestType">
            <mat-option value="Safety Incident Response">
              Safety Incident Response</mat-option
            >
            <mat-option value="Security Incident Response">
              Security Incident Response
            </mat-option>
            <mat-option value="Maintenance / Repair Work Order">
              Maintenance / Repair Work Order
            </mat-option>
            <mat-option value="Environmental Hazard Report">
              Environmental Hazard Report
            </mat-option>
            <mat-option value="Energy Systems Support">
              Energy Systems Support
            </mat-option>
            <mat-option value="Compliance Advisory / Remediation">
              Compliance Advisory / Remediation
            </mat-option>
            <mat-option value="IT / Technology Service Request">
              IT / Technology Service Request
            </mat-option>
            <mat-option value="Claims Management Request">
              Claims Management Request
            </mat-option>
            <mat-option value="General Service Request">
              General Service Request
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <br />
      <mat-form-field appearance="outline">
        <mat-label>Select Assign*</mat-label>
        <input
          matInput
          [formControl]="selectedUsersControl"
          [matAutocomplete]="autoAdmin"
          formControlName="Assignee"
        />
        <mat-icon
          style="background-color: transparent; color: #e93578"
          matSuffix
          (click)="clearInputField()"
          >clear</mat-icon
        >
        <mat-autocomplete
          (optionSelected)="addUser($event)"
          #autoAdmin="matAutocomplete"
        >
          <mat-option
            *ngFor="let host of filteredAssignee"
            [value]="host.firstname + ' ' + host.lastname"
          >
            <img
              class="visitor-img"
              [src]="host.profilePicture"
              height="30"
              width="36"
            />
            <span> {{ host.firstname + " " + host.lastname }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <br />
      <div class="selected-users" *ngIf="usersTemp.length > 0">
        <mat-chip
          *ngFor="let user of usersTemp"
          [removable]="true"
          (removed)="removeUser(user)"
        >
          {{ user }}
          <mat-icon matChipRemove *ngIf="!isSupport">cancel</mat-icon>
        </mat-chip>
        <br />
      </div>
      <mat-form-field appearance="outline">
        <mat-label>
          {{
            lodgeComplaintTicket.controls.complainSubject.value === "Claim"
              ? "Claim Description"
              : lodgeComplaintTicket.controls.complainSubject.value === "Leave"
              ? "Leave Reason"
              : "Description"
          }}
        </mat-label>
        <textarea
          formControlName="complainDescription"
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="4"
          matInput
        ></textarea>
      </mat-form-field>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 10px;
        "
        class="leave-request-container"
        *ngIf="lodgeComplaintTicket.controls.complainSubject.value === 'Leave'"
      >
        <mat-radio-group
          (change)="onChangeSelectedRadio($event)"
          formControlName="leaveType"
        >
          <mat-radio-button value="1">Single</mat-radio-button>
          <mat-radio-button value="2">Multiple</mat-radio-button>
        </mat-radio-group>
        <mat-form-field
          appearance="outline"
          *ngIf="lodgeComplaintTicket.controls.leaveType.value === '1'"
        >
          <mat-label>Select Leave Date</mat-label>
          <input
            matInput
            formControlName="singleDate"
            readonly
            [matDatepicker]="Datepicker"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="Datepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #Datepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          *ngIf="lodgeComplaintTicket.controls.leaveType.value === '2'"
        >
          <mat-label>Enter a date(s) </mat-label>
          <mat-date-range-input
            [formGroup]="lodgeComplaintTicket"
            [rangePicker]="picker"
          >
            <input
              matStartDate
              formControlName="startDate"
              placeholder="Start date"
            />
            <input
              matEndDate
              formControlName="endDate"
              placeholder="End date"
            />
          </mat-date-range-input>
          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          @if (range.controls.start.hasError('matStartDateInvalid')) {
          <mat-error>Invalid start date</mat-error>
          } @if (range.controls.end.hasError('matEndDateInvalid')) {
          <mat-error>Invalid end date</mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field
        appearance="outline"
        *ngIf="lodgeComplaintTicket.controls.complainSubject.value === 'Claim'"
      >
        <mat-label>Claim Amount</mat-label>
        <input
          formControlName="claimAmount"
          (keypress)="inputValidator($event)"
          matInput
        />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        *ngIf="lodgeComplaintTicket.controls.complainSubject.value === 'Claim'"
      >
        <mat-label>Claim Type</mat-label>
        <mat-select formControlName="claimType">
          <mat-option value="Party">Damage</mat-option>
          <mat-option value="Official">Accidental</mat-option>
          <mat-option value="Social">Medical</mat-option>
          <mat-option value="Meeting">Content</mat-option>
          <mat-option value="Gathering">Vehicle</mat-option>
          <mat-option value="Other">Other</mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <div class="attachment-wrapper">
        <div class="attachment-name">
          <p>
            <b>{{
              selectedAttachment?.name
                ? (selectedAttachment.name | truncateCase : 12)
                : "Upload"
            }}</b>
          </p>
        </div>
        <button type="button" (click)="fileInput1.click()" mat-icon-button>
          <mat-icon>attach_file</mat-icon>
        </button>

        <input
          type="file"
          #fileInput1
          style="display: none"
          accept=".pdf, .jpeg, .png"
          (change)="onAttachmentSelected($event)"
        />
      </div> -->
      <mat-form-field appearance="outline">
        <mat-label>Priority</mat-label>
        <mat-select formControlName="incidentCriticality">
          <mat-option value="High">High</mat-option>
          <mat-option value="Medium">Medium</mat-option>
          <mat-option value="Low">Low</mat-option>
        </mat-select>
      </mat-form-field>
      <div
        class="attachment-wrapper"
        *ngIf="lodgeComplaintTicket.controls.complainSubject.value !== 'Leave'"
      >
        <div class="attachment-uploaded-content">
          <ng-container *ngFor="let file of selectedAttachments; let i = index">
            <div class="attachment-name">
              <p>
                <b
                  >{{ i + 1 + "." }} &nbsp;{{
                    file.name | truncateCase : 12
                  }}</b
                >
              </p>
            </div>
          </ng-container>
          <ng-container *ngIf="selectedAttachments.length == 0">
            <div class="attachment-name" style="justify-content: center">
              <p>
                <b>{{ "Upload" }}</b>
              </p>
            </div>
          </ng-container>
        </div>
        <button type="button" (click)="fileInput1.click()" mat-icon-button>
          <mat-icon>{{
            selectedAttachments.length > 0 ? "add" : "attach_file"
          }}</mat-icon>
        </button>
        <input
          type="file"
          #fileInput1
          style="display: none"
          accept=".pdf, .jpeg, .png"
          multiple
          (change)="onAttachmentSelected($event)"
        />
      </div>
      <div
        class="checkbox-container"
        *ngIf="
          lodgeComplaintTicket.controls.complainSubject.value != null &&
          lodgeComplaintTicket.controls.complainSubject.value !== 'Claim' &&
          lodgeComplaintTicket.controls.complainSubject.value !== 'Complain'
        "
      >
        <mat-checkbox formControlName="isRecurring"
          >Make Recurring</mat-checkbox
        >
      </div>
      <div *ngIf="lodgeComplaintTicket.controls.isRecurring.value">
        <br />
        <!-- <mat-form-field appearance="outline">
          <mat-label>Select Frequency</mat-label>
          <mat-select
            formControlName="selectedFrequency"
            (selectionChange)="onFrequencyChange($event)"
          >
            <mat-option value="everyday">Everyday</mat-option>
=
            <mat-option [matMenuTriggerFor]="daysMenu"
              >Specific Day of the Week</mat-option
            >
            <mat-menu #daysMenu="matMenu">
              <mat-selection-list
                [formControl]="lodgeComplaintTicket.controls.selectedDates"
              >
                <mat-list-option *ngFor="let day of daysOfWeek" [value]="day">{{
                  day
                }}</mat-list-option>
              </mat-selection-list>
            </mat-menu>
=
            <mat-option [matMenuTriggerFor]="datesMenu"
              >Specific Date of Month</mat-option
            >
            <mat-menu #datesMenu="matMenu">
              <mat-selection-list
                [formControl]="lodgeComplaintTicket.controls.selectedDays"
              >
                <mat-list-option
                  *ngFor="let date of datesOfMonth"
                  [value]="date"
                  >{{ date }}</mat-list-option
                >
              </mat-selection-list>
            </mat-menu>

            <mat-option value="twiceAWeek">Twice a Week</mat-option>
=
            <mat-option value="twiceAMonth">Twice a Month</mat-option>
          </mat-select>
        </mat-form-field> -->
        <mat-form-field appearance="outline">
          <mat-label>Select Frequency</mat-label>
          <mat-select
            formControlName="selectedFrequency"
            (selectionChange)="onFrequencyChange($event)"
          >
            <!-- Everyday Option -->
            <mat-option value="everyday">Everyday</mat-option>

            <!-- Specific Day of the Week Option -->
            <mat-option value="specificDay"
              >Specific Day of the Week</mat-option
            >

            <!-- Specific Date of Month Option -->
            <mat-option value="specificDate">Specific Date of Month</mat-option>

            <!-- Twice a Week Option -->
            <mat-option value="twiceAWeek">Twice a Week</mat-option>

            <!-- Twice a Month Option -->
            <mat-option value="twiceAMonth">Twice a Month</mat-option>
          </mat-select>
        </mat-form-field>
        <div
          *ngIf="
            lodgeComplaintTicket.controls.selectedFrequency.value ===
              'specificDay' ||
            lodgeComplaintTicket.controls.selectedFrequency.value ===
              'twiceAWeek'
          "
        >
          <mat-form-field appearance="outline">
            <mat-label>Select Day(s)</mat-label>
            <mat-select
              formControlName="selectedDays"
              [multiple]="true"
              (selectionChange)="selectionLimit($event, 'day')"
            >
              <mat-option *ngFor="let day of daysOfWeek" [value]="day">{{
                day
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div
          *ngIf="
            lodgeComplaintTicket.controls.selectedFrequency.value ===
              'specificDate' ||
            lodgeComplaintTicket.controls.selectedFrequency.value ===
              'twiceAMonth'
          "
        >
          <mat-form-field appearance="outline">
            <mat-label>Select Date(s)</mat-label>
            <mat-select
              formControlName="selectedDates"
              [multiple]="true"
              (selectionChange)="selectionLimit($event, 'date')"
            >
              <mat-option *ngFor="let date of datesOfMonth" [value]="date">{{
                date
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <br />
        <div class="selected-options" *ngIf="false">
          {{ lodgeComplaintTicket.controls.selectedFrequency.value | json }}
          <h3>Selected Frequency:</h3>
          <p
            *ngIf="
              lodgeComplaintTicket.controls.selectedFrequency.value ===
              'everyday'
            "
          >
            Everyday
          </p>
          <p
            *ngIf="
              lodgeComplaintTicket.controls.selectedFrequency.value ===
              'twiceAWeek'
            "
          >
            Twice a Week
          </p>
          <p
            *ngIf="
              lodgeComplaintTicket.controls.selectedFrequency.value ===
              'twiceAMonth'
            "
          >
            Twice a Month
          </p>
          <p
            *ngIf="
              lodgeComplaintTicket.controls.selectedFrequency.value ===
              'specificDay'
            "
          >
            Specific Days of the Week:
            <span
              *ngFor="
                let day of lodgeComplaintTicket.controls.selectedDays.value
              "
            >
              {{ day }}
            </span>
          </p>
          <p
            *ngIf="
              lodgeComplaintTicket.controls.selectedFrequency.value ===
              'specificDate'
            "
          >
            Specific Dates of the Month:
            <span
              *ngFor="
                let date of lodgeComplaintTicket.controls.selectedDates.value
              "
            >
              {{ date }}
            </span>
          </p>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!-- <button mat-raised-button mat-dialog-close cdkFocusInitial>Close</button> -->
  <button
    [disabled]="lodgeComplaintTicket.invalid"
    mat-raised-button
    [mat-dialog-close]="lodgeComplaintTicket.value"
  >
    Submit
  </button>
</mat-dialog-actions>
